import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import styles from "./style.module.scss";

interface CounterButtonPropsType {
  counter: number;
  setCounter: any;
  max?: number;
}

const CounterButton = ({ counter, setCounter, max }: CounterButtonPropsType) => {
  const handleDecrement = () => {
    setCounter((prevValue: number) => {
      if (!prevValue || prevValue <= 1) {
        return 1;
      }
      return prevValue - 1;
    });
  };

  const handleIncrement = () => {
    setCounter((prevValue: number) => {
      if (max !== undefined && prevValue >= max) {
        return max;
      }
      return prevValue + 1;
    });
  };

  return (
    <div className={styles.buttonWrapper}>
      <button onClick={() => handleDecrement()}>
        <RemoveIcon />
      </button>
      <input
        inputMode="numeric"
        value={counter === 0 ? "" : counter}
        onKeyDown={(e) => {
          if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
          const pasted = e.clipboardData.getData("text");
          if (!/^\d+$/.test(pasted)) {
            e.preventDefault();
          }
        }}
        onChange={(e) => {
          const digitsOnly = e.target.value.replace(/\D/g, "");
          const raw = digitsOnly.replace(/^0+(?=\d)/, "");
          if (raw === "") {
            setCounter(0);
            return;
          }
          const next = Number(raw);
          if (max !== undefined && next > max) {
            setCounter(max);
            return;
          }
          setCounter(next);
        }}
        type="number"
        min={1}
        max={max}
      />
      <button onClick={() => handleIncrement()}>
        <AddIcon />
      </button>
    </div>
  );
};

export default CounterButton;
